module.exports = __webpack_public_path__ + "static/media/bts.de56eb3e.svg";